import { useNavigate } from 'react-router-dom';
import { Button, Heading, Text } from '@dekafvv/sharedfrontend';
import React from 'react';
import styles from './footer.module.css';
import { footerLinks, linkActions, type TFooterLink } from './footerLinks';

export const Header2 = ({ children } : {children: React.ReactNode}) => (<Heading size={2} className="mt-6 mb-3 text-xl">{children}</Heading>);
export const Header3 = ({ children } : {children: React.ReactNode}) => (<Heading size={3} className="mt-6 mb-3 text-lg">{children}</Heading>);
export const Header4 = ({ children } : {children: React.ReactNode}) => (<Heading size={4} className="mt-2 mb-1 text-base">{children}</Heading>);
export const Li = ({ children } : {children: React.ReactNode}) => (<li className="mb-2 pl-2 text-base leading-7 text-[color:var(--primary-darker)]">{children}</li>);
export const FooterText = ({ children } : {children: React.ReactNode}) => (<Text className="!leading-7">{children}</Text>);
export const AddressText = ({ children } : {children: React.ReactNode}) => (<Text fontSize="lg" className="!leading-8 mb-8">{children}</Text>);
export const PhoneText = ({ children } : {children: React.ReactNode}) => (<Text fontSize="lg" className="!leading-8 colored">{children}</Text>);
export const PhoneLink = ({ children, href } : {children: React.ReactNode, href: string}) => (<a className="!leading-8 colored text-lg" href={href}>{children}</a>);
export const FooterLink = ({ children, href } : {children: React.ReactNode, href: string}) => (<a href={href} className="footer-link">{children}</a>);
const Footer = () => {
    const navigate = useNavigate();

    const handleClick = (linkProp:TFooterLink) => {
        if (linkProp.action === linkActions.navigate) {
            navigate(`${linkProp.link}`);
        }
        if (linkProp.action === linkActions.cmp) {
            // eslint-disable-next-line no-underscore-dangle
            window.__cmp('showScreenAdvanced');
        }
        if (linkProp.action === linkActions.link) {
            window.open(linkProp.redirectLink, '_blank');
        }
    };

    return (
        <footer className={styles['footer-container']}>
            {
                footerLinks.map((link) => (
                    <Button
                        onClick={() => handleClick(link)}
                        className={styles['footer-link']}
                        buttonType="link"
                        key={link.link}
                    >
                        {link.title}
                    </Button>
                ))
            }

        </footer>
    );
};

export default Footer;
